<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Datenschutzerklärung</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">1. Verantwortliche Stelle</h4>
            <h5 class="description list">
              Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der EU-DSGVO ist:<br>
              Podologiepraxis Boldt<br>
              Inhaberin: Natalja Boldt<br>
              Hufelandstraße 14<br>
              34537 Bad Wildungen<br><br>
              E-Mail: kontakt@podologie-boldt.de<br>
              Telefon: 05621 / 96 78 78 6
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">2. Allgemeine Hinweise</h4>
            <h5 class="description list">
              Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Wir verarbeiten Ihre Daten gemäß den Vorschriften der DSGVO und des Bundesdatenschutzgesetzes (BDSG).
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">3. Hosting / Server-Logfiles</h4>
            <h5 class="description list">
              Unsere Website wird bei STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin, Deutschland gehostet.<br>
              Strato verarbeitet personenbezogene Daten (z. B. IP-Adresse, Browserdaten, Uhrzeit des Zugriffs) zur Bereitstellung der Website und zur Sicherstellung des Betriebs. Die Nutzung von Strato erfolgt auf der Rechtsgrundlage unseres berechtigten Interesses an einem zuverlässigen Betrieb der Website (Art. 6 Abs. 1 lit. f DSGVO). Ein Vertrag zur Auftragsverarbeitung wurde abgeschlossen.<br>
              Weitere Infos: https://www.strato.de/datenschutz/
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">4. Erhebung von Zugriffsdaten</h4>
            <h5 class="description list">
              Beim Besuch unserer Website werden automatisch Informationen an den Server übermittelt (Server-Logfiles). Dabei handelt es sich z. B. um:<br>
              IP-Adresse<br>
              Datum & Uhrzeit des Zugriffs<br>
              Verwendeter Browser<br>
              Betriebssystem<br>
              Referrer URL<br>
              Diese Daten werden ausschließlich zur Sicherstellung des Betriebs, zur Fehleranalyse und zur Optimierung der Website verwendet und nicht mit anderen Datenquellen zusammengeführt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">5. Kontaktformular</h4>
            <h5 class="description list">
              Wenn Sie uns über das Kontaktformular personenbezogene Daten (z. B. Name, E-Mail, Telefonnummer, Nachricht) übermitteln, verwenden wir diese Daten ausschließlich zur Bearbeitung Ihrer Anfrage und Kontaktaufnahme. Die Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO (Bearbeitung Ihrer Anfrage/vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (Bereich Pflege der Kundenbeziehung).<br>
              Nach vollständiger Bearbeitung Ihrer Anfrage werden diese Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">6 Google Maps</h4>
            <h5 class="description list">
              Diese Website nutzt den Kartendienst Google Maps, um interaktive Karten darzustellen. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.<br>
              Zur Nutzung von Google Maps wird Ihre IP-Adresse an Google übermittelt und ggf. in den USA gespeichert. Dies geschieht auf Grundlage unseres berechtigten Interesses an einer benutzerfreundlichen Darstellung unserer Praxisstandorte (Art. 6 Abs. 1 lit. f DSGVO).<br>
              Weitere Informationen zum Datenschutz bei Google Maps:<br>
              https://policies.google.com/privacy
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">7. Verlinkung zu WhatsApp</h4>
            <h5 class="description list">
              Unsere Website enthält eine direkte Verlinkung zu WhatsApp, über die Sie uns kontaktieren können. Wenn Sie diese Funktion nutzen, gelten die Datenschutzbestimmungen von WhatsApp/Meta Platforms Inc.<br>
              Daten, die dabei auf Ihrem Gerät oder bei WhatsApp gespeichert bzw. übertragen werden, unterliegen den jeweiligen Nutzungs- und Datenschutzrichtlinien von WhatsApp: https://www.whatsapp.com/legal/#privacy-policy<br>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">8. Cookies</h4>
            <h5 class="description list">
              Unsere Website verwendet Cookies, um grundlegende Funktionen bereitzustellen und die Nutzung zu erleichtern. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Sie können die Speicherung von Cookies über Ihre Browsereinstellungen kontrollieren oder verhindern.<br>
              Nicht unbedingt notwendige Cookies werden nur mit Ihrer Einwilligung gesetzt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">9. Ihre Rechte</h4>
            <h5 class="description list">
              Sie haben als betroffene Person nach der DSGVO u. a. folgende Rechte:<br>
              Recht auf Auskunft über Ihre gespeicherten Daten<br>
              Recht auf Berichtigung unrichtiger Daten<br>
              Recht auf Löschung Ihrer Daten<br>
              Recht auf Einschränkung der Verarbeitung<br>
              Recht auf Datenübertragbarkeit<br>
              Recht auf Widerruf einer Einwilligung<br>
              Recht auf Beschwerde bei einer Aufsichtsbehörde<br>
              Verantwortlich bleibt die Podologiepraxis Boldt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">10. Beschwerderecht</h4>
            <h5 class="description list">
              Sie haben das Recht, sich bei einer zuständigen Datenschutz-Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass Ihre Daten unrechtmäßig verarbeitet werden.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">11. Datensicherheit</h4>
            <h5 class="description list">
              Wir schützen Ihre Daten durch geeignete technische und organisatorische Maßnahmen vor unbefugtem Zugriff, Verlust, Zerstörung oder Manipulation.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'privacy',
  bodyClass: 'privacy-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
